var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4.00023H7.3C5.61984 4.00023 4.77976 4.00023 4.13803 4.32721C3.57354 4.61483 3.1146 5.07377 2.82698 5.63826C2.5 6.27999 2.5 7.12007 2.5 8.80023V17.2002C2.5 18.8804 2.5 19.7205 2.82698 20.3622C3.1146 20.9267 3.57354 21.3856 4.13803 21.6732C4.77976 22.0002 5.61984 22.0002 7.3 22.0002H15.7C17.3802 22.0002 18.2202 22.0002 18.862 21.6732C19.4265 21.3856 19.8854 20.9267 20.173 20.3622C20.5 19.7205 20.5 18.8804 20.5 17.2002V13.0002M8.49997 16.0002H10.1745C10.6637 16.0002 10.9083 16.0002 11.1385 15.945C11.3425 15.896 11.5376 15.8152 11.7166 15.7055C11.9184 15.5818 12.0914 15.4089 12.4373 15.063L22 5.50023C22.8284 4.6718 22.8284 3.32865 22 2.50023C21.1716 1.6718 19.8284 1.6718 19 2.50022L9.43723 12.063C9.09133 12.4089 8.91838 12.5818 8.79469 12.7837C8.68504 12.9626 8.60423 13.1577 8.55523 13.3618C8.49997 13.5919 8.49997 13.8365 8.49997 14.3257V16.0002Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.4f7eb063251e8101dc35a8e89db324d1.svg";
export { ForwardRef as ReactComponent };